import { FromTableBaseCollectionFilterRequestBuilder } from './from-table-base-collection-filter-request.builder';
import { CollectionFilterOperator } from '../enums/collection-filter-operator';
import { isNil, Nillable } from '@web/utils';
import { CollectionFilterKey } from '../../collection/types/collection-filter-key';
import { CollectionFilterRequest } from '../requests';

export class FromTableDateCollectionFilterRequestBuilder<
  Filter,
> extends FromTableBaseCollectionFilterRequestBuilder<Filter> {
  public range(): this {
    return this.operator(CollectionFilterOperator.DateRange);
  }

  public rangeFor(property: CollectionFilterKey<Filter>): this {
    return this.range().property(property);
  }

  public override build(): Nillable<CollectionFilterRequest> {
    this.configureDefaultOperator();

    return super.build();
  }

  private configureDefaultOperator(): void {
    if (!isNil(this._operator)) {
      return;
    }

    this.range();
  }
}
